import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { BuildingTypeSelect } from '../BuildingTypeSelect'

function BuildingTypeSelectFormikField({
  Select = BuildingTypeSelect,
  ...restProps
}) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default BuildingTypeSelectFormikField
